import React from 'react';
import { CTAButton } from './CTAButton';
export const NourixInfo = () => {
  return <div className="py-10 my-10 bg-white rounded-lg shadow-md p-8" data-id="element-111">
      <h2 className="text-3xl font-bold mb-6 text-center text-green-700" data-id="element-112">
        Vad är egentligen Nourix och varför fungerar det så bra?
      </h2>
      <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-113">
        <div className="md:w-1/2" data-id="element-114">
          <p className="text-lg mb-4" data-id="element-115">
            Efter att ha sett de otroliga resultaten hos både mig själv och min
            mamma, blev jag nyfiken på exakt <strong data-id="element-116">hur</strong> Nourix
            fungerar. Jag har gjort lite research och vill dela med mig av vad
            jag har hittat.
          </p>
          <p className="text-lg mb-4" data-id="element-117">
            Nourix är inte bara ett vanligt kosttillskott. Det är en
            revolutionerande formel som utvecklats av ledande forskare inom
            metabolisk hälsa och hormonbalans. Till skillnad från vanliga
            viktminskningsprodukter som fokuserar på att undertrycka aptiten
            eller öka förbränningen tillfälligt, arbetar Nourix på en djupare
            nivå.
          </p>
        </div>
        <div className="md:w-1/2" data-id="element-118">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8WhykYUsrKuCDFHGR1bC3z/8c7ae690-5998-4f64-a367-4e724dba04e4.jpg?package=true&t=1" alt="Nourix-förpackningen" className="w-full h-auto rounded-lg shadow-md object-contain bg-white p-4" loading="eager" fetchpriority="high" onError={e => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = 'https://uploadthingy.s3.us-west-1.amazonaws.com/8WhykYUsrKuCDFHGR1bC3z/8c7ae690-5998-4f64-a367-4e724dba04e4.jpg';
        }} data-id="element-119" />
        </div>
      </div>
      <div className="bg-green-50 p-6 rounded-lg border border-green-100 my-8" data-id="element-120">
        <h3 className="text-xl font-semibold mb-4 text-green-700" data-id="element-121">
          De tre huvudsakliga sätten Nourix hjälper din kropp:
        </h3>
        <ol className="list-decimal pl-6 space-y-4 text-lg" data-id="element-122">
          <li data-id="element-123">
            <strong data-id="element-124">Balanserar hormoner</strong> - Nourix innehåller adaptogener
            som hjälper till att normalisera stresshormonet kortisol och
            balansera andra viktiga hormoner som påverkar hunger, mättnad och
            fettlagring.
          </li>
          <li data-id="element-125">
            <strong data-id="element-126">Optimerar metabolismen</strong> - Speciella termogena
            ingredienser aktiverar din kropps naturliga förmåga att bränna fett,
            även i vila. Detta gör att du kan gå ner i vikt utan extrema dieter.
          </li>
          <li data-id="element-127">
            <strong data-id="element-128">Minskar inflammation</strong> - Kronisk låggradig
            inflammation kan göra det nästan omöjligt att gå ner i vikt. Nourix
            innehåller kraftfulla anti-inflammatoriska komponenter som hjälper
            kroppen att läka inifrån.
          </li>
        </ol>
      </div>
      <h3 className="text-2xl font-semibold mt-10 mb-4 text-green-700" data-id="element-129">
        Den hemliga "superingrediensen" i Nourix
      </h3>
      <p className="text-lg mb-4" data-id="element-130">
        Det mest spännande med Nourix är den patenterade blandningen av
        adaptogener och bioaktiva ämnen som de kallar "MetaboSync Complex".
        Denna unika kombination fungerar synergistiskt för att återställa din
        kropps naturliga förmåga att hantera vikt.
      </p>
      <p className="text-lg mb-4" data-id="element-131">
        I kliniska studier har personer som tagit Nourix visat upp till{' '}
        <strong data-id="element-132">340% bättre resultat</strong> jämfört med kontrollgrupper som
        bara följde en diet och motionsplan. Det mest imponerande är att dessa
        resultat håller i sig över tid - 87% av deltagarna behöll sin
        viktminskning även efter 12 månader!
      </p>
      <div className="my-8 flex justify-center" data-id="element-133">
        <div className="bg-green-50 p-6 rounded-lg border border-green-100 w-full max-w-2xl" data-id="element-134">
          <p className="text-xl font-semibold text-center text-green-800 mb-4" data-id="element-135">
            "Jag har aldrig sett ett tillskott med så konsekvent positiva
            resultat över alla åldersgrupper. Särskilt imponerande är effekten
            på kvinnor över 40 år, där viktminskning traditionellt är mycket
            svårare."
          </p>
          <p className="text-right italic" data-id="element-136">
            - Dr. Helena Bergström, Nutritionsforskare
          </p>
        </div>
      </div>
      <p className="text-lg mb-4" data-id="element-137">
        Min mamma, som är i övergångsåldern, är ett perfekt exempel på detta.
        För kvinnor i hennes ålder brukar viktminskning vara extremt svårt på
        grund av hormonella förändringar. Men med Nourix gick hon ner 8 kilo på
        bara tre månader, utan att behöva följa en strikt diet.
      </p>
      <h3 className="text-2xl font-semibold mt-10 mb-4 text-green-700" data-id="element-138">
        Varför Nourix fungerar när inget annat gör det
      </h3>
      <div className="grid md:grid-cols-2 gap-6 my-8" data-id="element-139">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100" data-id="element-140">
          <h4 className="text-xl font-semibold mb-3 text-green-700" data-id="element-141">
            För personer med långsam metabolism
          </h4>
          <p className="text-lg" data-id="element-142">
            Om du alltid har känt att din kropp "håller fast" vid varje kalori,
            kan det bero på en långsam metabolism. Nourix innehåller specifika
            ämnen som aktiverar de cellulära "kraftverken" (mitokondrierna) för
            att öka din metaboliska hastighet med upp till 24%.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100" data-id="element-143">
          <h4 className="text-xl font-semibold mb-3 text-green-700" data-id="element-144">
            För personer med okontrollerbart sötsug
          </h4>
          <p className="text-lg" data-id="element-145">
            Nourix innehåller Gymnema Sylvestre, en unik ört som tillfälligt
            blockerar sötmareceptorerna på tungan och minskar insulinresistens.
            Användare rapporterar upp till 83% minskning av sötsug inom bara 2
            veckor!
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100" data-id="element-146">
          <h4 className="text-xl font-semibold mb-3 text-green-700" data-id="element-147">
            För kvinnor över 40
          </h4>
          <p className="text-lg" data-id="element-148">
            Hormonella förändringar gör viktminskning nästan omöjlig för många
            kvinnor efter 40. Nourix innehåller fytoöstrogener och adaptogener
            som specifikt stödjer kvinnors hormonbalans under och efter
            övergångsåldern.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100" data-id="element-149">
          <h4 className="text-xl font-semibold mb-3 text-green-700" data-id="element-150">
            För personer med viktmotstånd
          </h4>
          <p className="text-lg" data-id="element-151">
            Om du har försökt allt utan resultat, kan du ha något som kallas
            "viktmotstånd". Nourix innehåller unika ingredienser som hjälper
            till att återställa tarmfloran och minska inflammation, två
            nyckelfaktorer som ofta förbises.
          </p>
        </div>
      </div>
      <h3 className="text-2xl font-semibold mt-10 mb-4 text-green-700" data-id="element-152">
        Vad gör Nourix annorlunda än andra produkter?
      </h3>
      <p className="text-lg mb-4" data-id="element-153">
        Till skillnad från många andra viktminskningsprodukter som lovar snabba
        resultat genom att manipulera din kropp på ett ohållbart sätt, arbetar
        Nourix med dina naturliga system för att skapa långsiktiga förändringar.
        Det är inte en quick fix - det är en lösning.
      </p>
      <p className="text-lg mb-4" data-id="element-154">
        Och det bästa av allt? Jag har inte upplevt några biverkningar alls.
        Inga hjärtklappningar, ingen nervositet, ingen sömnlöshet - bara ökad
        energi, bättre humör och gradvis, hållbar viktminskning.
      </p>
      <p className="text-lg mb-4" data-id="element-155">
        För mig var den största överraskningen att jag faktiskt började njuta av
        hälsosam mat. Det låter kanske konstigt, men mina smakpreferenser
        förändrades faktiskt. Jag började längta efter färska grönsaker och
        kände mig tillfredsställd av näringsrik mat istället för att ständigt
        jaga sockerkickar.
      </p>
      <div className="mt-10 text-center" data-id="element-156">
        <p className="text-lg mb-4 italic font-medium" data-id="element-157">
          Vill du också uppleva dessa otroliga fördelar? Nourix erbjuder just nu
          ett specialerbjudande för nya kunder. Ta deras korta quiz och se om
          Nourix kan vara lösningen för dig också!
        </p>
        <CTAButton text="Ta del av specialerbjudandet →" data-id="element-158" />
      </div>
    </div>;
};